import type { VideoSource } from '../../../../shared/protocol';
import { detectVideoSource } from './VideoSourceDetector';

export function parseMediaUrl(input: string): VideoSource | null {
  const detected = detectVideoSource(input);
  return detected.kind === 'supported' ? detected.source : null;
}
